import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUser } from "./api/auth"; // Import the getUser function to check authentication

const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        await getUser(); // Check if user is logged in
        setIsAuthenticated(true);
        navigate("/furnish-home"); // Redirect to furnish-home if already authenticated
      } catch (error) {
        setIsAuthenticated(false); // Set as not authenticated if check fails
      }
    };

    checkAuthentication();
  }, [navigate]);

  // Show nothing while checking authentication
  if (isAuthenticated === null) {
    return null;
  }

  return <>{children}</>;
};

export default PublicRoute;
